import React, { useState } from "react";
import { FormControl, InputLabel, Select, MenuItem } from "@material-ui/core";

const timeOptions = [
  { value: "", label: "Todos" },
  { value: "0-5", label: "0 a 5 min" },
  { value: "5-15", label: "5 a 15 min" },
  { value: "15-30", label: "15 a 30 min" },
  { value: "30-60", label: "30 a 60 min" },
  { value: "60+", label: "Mais de 1h" },
];

export function SupportTimeFilter({ onFiltered }) {
  const [selected, setSelected] = useState("");

  const handleChange = (e) => {
    const value = e.target.value;
    setSelected(value);
    onFiltered(value || null);
  };

  return (
    <FormControl variant="outlined" size="small" fullWidth>
      <InputLabel>Tempo de atendimento</InputLabel>
      <Select
        value={selected}
        onChange={handleChange}
        label="Tempo de atendimento"
      >
        {timeOptions.map((opt) => (
          <MenuItem key={opt.value} value={opt.value}>
            {opt.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}

export default SupportTimeFilter;
